import { BRAND_NAMES } from 'core/whiteLabel/whiteLabel';

export const SELLER_LABELS = {
  [BRAND_NAMES.FLARE]: 'Seller',
  [BRAND_NAMES.NETSPARK]: 'NetSpark Rep',
};
